import {AUTH_CONSTANTS}  from './auth/constants';

export const FEATURE_CONSTANTS = {
    AUTH: AUTH_CONSTANTS,
}